import { ITransaction } from '../models';

export function fromJsonApi(data): ITransaction {
  return {
    id: data.id,
    amount: data.attributes.amount,
    currency: data.attributes.currency,
    status: data.attributes.status,
    transactedAt: data.attributes.transacted_at,
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/transaction.ts